import { commitMutation, graphql } from 'react-relay/legacy';

const mutation = graphql`
    mutation drsmUserAddAddressMutation($input: UserAddAddressInput!) {
        userAddAddress(input: $input) {
            address {
                serviceId
                firstName
                lastName
            }
        }
    }
`;

function commit(environment, args) {
    const { userId, address, onSuccess, onFailure } = args;
    const variables = {
        input: {
            userId,
            address,
        },
    };

    commitMutation(environment, {
        mutation,
        variables,
        onCompleted: (payload, errors) => {
            if (errors) {
                onFailure(errors);
            } else {
                onSuccess(payload);
            }
        },
        onError: error => {
            onFailure([error]);
        },
    });
}

export default { commit };
